import { helper } from '@ember/component/helper';

export function periodUnit([period]) {
  // monthly -> month, yearly -> year
  return period.replace(/ly$/, '');
}

export default helper(periodUnit);
